import { AnyAction, Reducer, combineReducers } from 'redux';
import { ThunkAction } from 'redux-thunk';

import { IAccountStore, accountReducer } from './account/reducer';
import { IAccountActions } from './account/actions';
import { ISnackbarStore, snackbarReducer } from './snackbar/reducer';
import { ISnackbarActions } from './snackbar/actions';
import { ILoaderStore, loaderReducer } from './loader/reducer';
import { ILoaderActions } from './loader/actions';
import { IMembershipStore, membershipReducer } from './membership/reducer';
import { IMembershipActions } from './membership/actions';
import { ISwapStore, swapReducer } from './swap/reducer';
import { ISwapActions } from './swap/actions';
import { ILOVStore, lovReducer } from './lov/reducer';
import { ILOVActions } from './lov/actions';

export type IRequestAction = ThunkAction<
  Promise<any>,
  IStore,
  undefined,
  AnyAction
>;

export type IAllActions =
  | IAccountActions
  | ISnackbarActions
  | ILoaderActions
  | IMembershipActions
  | ISwapActions
  | ILOVActions;

export interface IStore {
  snackbar: ISnackbarStore;
  loader: ILoaderStore;
  account: IAccountStore;
  membership: IMembershipStore;
  swap: ISwapStore;
  lov: ILOVStore;
}

export const rootReducer: Reducer<IStore, IAllActions> = combineReducers({
  snackbar: snackbarReducer,
  loader: loaderReducer,
  account: accountReducer,
  membership: membershipReducer,
  swap: swapReducer,
  lov: lovReducer,
});
